import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { Button } from "src/base-components/Button";
import { EventFilterGroup } from "src/eventsCatalogue/filters/EventFilterGroup";
import {
  DEFAULT_JUNCTION,
  MAX_FILTER_GROUPS,
} from "src/eventsCatalogue/filters/constants";
import {
  EventFilterFormData,
  Junction,
} from "src/eventsCatalogue/filters/types";
import { buildFilterCondition } from "src/eventsCatalogue/filters/utils";

type EventFilterGroupsProps = {
  eventType: string;
};

export const EventFilterGroups: React.FC<EventFilterGroupsProps> = ({
  eventType,
}) => {
  const form = useFormContext<EventFilterFormData>();
  const {
    fields: groups,
    append,
    remove,
  } = useFieldArray<EventFilterFormData>({
    name: "filter_condition.conditions",
  });

  const handleAddGroup = () => {
    // Get the current junction from the first editable group (index 1)
    // If no groups exist yet or only one group exists, default to DEFAULT_JUNCTION
    const currentJunction: Junction =
      groups.length > 1
        ? (form.getValues(
            `filter_condition.conditions.1.junction`,
          ) as Junction) || DEFAULT_JUNCTION
        : DEFAULT_JUNCTION;

    append({
      junction: currentJunction,
      conditions: [buildFilterCondition(currentJunction)],
    });
  };

  return (
    <div className="flex flex-col gap-y-3">
      {groups.map((group, index) => (
        <EventFilterGroup
          key={group.id}
          eventType={eventType}
          groupIndex={index}
          mode={index === 0 ? "where" : "junction"}
          onRemove={groups.length > 1 ? () => remove(index) : undefined}
        />
      ))}
      <div>
        <Button
          dataLoc="add-filter-group"
          disabled={groups.length >= MAX_FILTER_GROUPS}
          iconLeft={faPlus}
          size="sm"
          variant="secondary"
          onClick={handleAddGroup}
        >
          Add filter group
        </Button>
      </div>
    </div>
  );
};
